import { useMemo } from 'react'

import { useQuery } from 'react-query'

import { REPORT_ENTITY_STALE_TIME_MS } from '@webapp/modules/reports/constants'
import { isNotFoundError } from '@webapp/modules/reports/utils/isNotFoundError'
import { DetailedUser } from '@webapp/platform/iam/entities/DetailedUser'
import { userQueryConfig } from '@webapp/platform/iam/query-configs/user'

// Reuses the iam domain's existing repository + query key (ADR-6/8) —
// GET /api/v3/users/{id}/, the v3 replacement for Angular's v2 envelope.
// `enabled` lets the config-driven detail FS call
// all three header hooks unconditionally (rules-of-hooks).
export const useQueryReportUser = (
  userId: number,
  enabled = true,
  { onError }: { onError?: (error: unknown) => void } = {}
) => {
  const { data, isFetching, error } = useQuery({
    ...userQueryConfig.getDetails(userId),
    staleTime: REPORT_ENTITY_STALE_TIME_MS,
    enabled,
    // A 404 is reported through `isNotFound`; only other failures reach
    // the caller's handler.
    onError:
      onError &&
      ((queryError: unknown) => {
        if (!isNotFoundError(queryError)) {
          onError(queryError)
        }
      }),
  })

  const user = useMemo(
    () => (data ? new DetailedUser(data.data) : null),
    [data]
  )

  return {
    user,
    isLoading: isFetching,
    isNotFound: isNotFoundError(error),
  }
}
